import { useState } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApi } from "@/lib/api";
import { PageHead, card, Field, Sel, inputCls } from "@/components/admin/kit";
import { download, useFetch } from "@/components/p4/shared";

const DOCS = [
  ["consent", "Patient consent slip", "Telugu + English, 2 slips per page: what the calls are, press 9 to stop, cost, signature.", true],
  ["leaflet", "Patient leaflet", "Telugu, large font: a call from your hospital at medicine time; press 2 to hear again, 9 to stop.", true],
  ["reception", "Receptionist guide", "1 page with screenshots: Quick enrol in 5 steps.", false],
  ["doctor", "Doctor summary", "1 page: what OnDose does, the monthly report, ₹69 per patient, free 30-day trial.", false],
];

export default function Printables() {
  const api = useApi();
  const [orgs] = useFetch(api, "/hospitals");
  const [hid, setHid] = useState("");
  const [cost, setCost] = useState("blank");
  const [amount, setAmount] = useState("");
  const q = (k) => `/admin/materials/${k}?hospital_id=${hid}&cost=${cost}${cost === "charged" ? `&amount=${amount}` : ""}`;
  return (
    <div className="grid gap-4" data-testid="printables-page">
      <PageHead title="Printable materials" sub="PDF downloads to print for hospitals." />
      <div className={`${card} grid gap-3 sm:grid-cols-3`}>
        <Field label="Hospital (for slip and leaflet)"><Sel value={hid} onChange={setHid} options={(orgs || []).map((h) => [h.id, h.name])} placeholder="Choose" testid="print-hospital" /></Field>
        <Field label="Cost to the patient (consent slip)"><Sel value={cost} onChange={setCost} options={[["blank", "Leave both boxes empty"], ["free", "Free for the patient"], ["charged", "Charged by hospital"]]} testid="print-cost" /></Field>
        {cost === "charged" && <Field label="₹ per month"><input type="number" min={1} className={inputCls} value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="print-amount" /></Field>}
      </div>
      {DOCS.map(([k, title, sub, needH]) => (
        <div key={k} className={`${card} flex flex-wrap items-center gap-3`} data-testid={`print-${k}`}>
          <div className="mr-auto"><p className="font-bold">{title}</p><p className="text-sm text-muted-foreground">{sub}</p></div>
          <Button disabled={(needH && !hid) || (k === "consent" && cost === "charged" && !(Number(amount) > 0))} onClick={() => download(api, q(k), `${title.replace(/ /g, "-")}.pdf`)} data-testid={`print-${k}-btn`}><Download size={14} /> PDF</Button>
        </div>
      ))}
    </div>
  );
}
